import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";
import { CalendarCheck, Mail, Mails, MessagesSquare, Send } from "lucide-react";
import React from "react";
import { useGetMessageActivitySummary } from "../hooks";

const MessageActivityDashboard = () => {
  const { data: messageActivitySummary } = useGetMessageActivitySummary();
  const statsData = [
    {
      title: "Total Messages",
      count: messageActivitySummary?.data?.totalMessages || 0,
      icon: <MessagesSquare className="h-8 w-8 text-blue-500" />,
    },
    {
      title: "Sent",
      count: messageActivitySummary?.data?.sent || 0,
      icon: <Send className="h-8 w-8 text-green-500" />,
    },
    {
      title: "Scheduled",
      count: messageActivitySummary?.data?.scheduled || 0,
      icon: <CalendarCheck className="h-8 w-8 text-orange-500" />,
    },
    {
      title: "Bulk Messages",
      count: messageActivitySummary?.data?.bulkMessages || 0,
      icon: <Mails className="h-8 w-8 text-red-500" />,
    },
    {
      title: "Individual Message",
      count: messageActivitySummary?.data?.individualMessages || 0,
      icon: <Mail className="h-8 w-8 text-red-500" />,
    },
  ];
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
      {statsData.map((stat, index) => (
        <QuickStatsCard
          key={index}
          title={stat.title}
          count={stat.count}
          icon={stat.icon}
        />
      ))}
    </div>
  );
};

export default MessageActivityDashboard;
